import React, { useEffect } from "react";
import SplashScreen from "../../components/SplashComponent/SplashScreen";
import { isEmpty } from "lodash";
import { useParams } from 'react-router-dom';
import { usePreSignupApi } from "../../api/usePreSignupApi";
import { silentLoginByAuthAPI } from "../../services/AuthService";
import { useTokenStore } from "../../storage/tokenState";
import { dispatchSwitchData } from "../../storage/switchState";
import { dispatchPreSignupConfig } from "../../storage/configState";
import { NAVIGATION_ROUTES } from "../../constant";
import useQueryParams from "../../hooks/useQueryParams";
import { PreSignUpConfig } from "../../storage/store";
import { setPreSignupConfig } from "../../utils/SessionManager";


const Splash: React.FC = () => {
  // const { partnerId } = useQueryParams(['partnerId']);
  // const { preSignupConfig, error, isLoading, refetch } = usePreSignupApi(partnerId as string);
  // const {
  //   token: userToken,
  //   splashConfig: { expiry, backgroundColor, video },
  //   language,
  // } = useTokenStore();
  // const accessToken = userToken?.accessToken;

  // useEffect(() => {
  //   const goToNextPage = async () => {
  //     if (isEmpty(preSignupConfig)) {
  //       await silentLoginByAuthAPI();
  //       return;
  //     }
  //   };
  //   goToNextPage();
  // }, [language, preSignupConfig]);

  // useEffect(() => {
  //   if (isEmpty(accessToken) && !isEmpty(preSignupConfig)) {
  //     dispatchPreSignupConfig(preSignupConfig as PreSignUpConfig);
  //     setPreSignupConfig(preSignupConfig);
  //   }
  // }, [preSignupConfig, error, isLoading, accessToken, language]);

  return(
    <>
      <SplashScreen />
    </>
  )
}

export default Splash;